import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { WebClientService } from '../../services/webclient-settings.service';
import { LanguageService } from '../../services/language.service';
/**
 * Lang Switcher Component
 */
let LanguageSwitcherComponent = class LanguageSwitcherComponent {
    constructor(languageService, wcss) {
        this.languageService = languageService;
        this.wcss = wcss;
        this.language = '';
        this.allLangs = [];
        this.wcss.data.subscribe(data => {
            this.allLangs = this.languageService.getAvailableLanguages();
            if (this.allLangs === undefined) {
                if (localStorage.getItem('all_langs')) {
                    this.allLangs = Object.values(localStorage.getItem('all_langs'));
                }
            }
            else {
                this.allLangs = Object.values(this.languageService.getAvailableLanguages());
            }
            this.language = this.languageService.getCurrentLanguage();
        });
    }
};
LanguageSwitcherComponent.ctorParameters = () => [
    { type: LanguageService },
    { type: WebClientService }
];
LanguageSwitcherComponent = __decorate([
    Component({
        selector: 'language-switcher',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./language-switcher.component.html")).default
    })
], LanguageSwitcherComponent);
export { LanguageSwitcherComponent };
